[
    {
        "namePrefix": "Mission 1",
        "nameSuffix": "Hallucination Hunter",
        "description": "Hi there! I've been sniffing around AI-generated content and let me tell you, not everything it says is accurate. Let's team up and learn how to spot the red flags together. Think you can tell what's real and what's not? I bet we can figure it out!",
        "shortDescription": "AI sounds confident even when it's flat-out wrong. Let's sniff out the red flags and figure out what's real together!",
        "categorySuffix": "level-1:hallucination hunter",
        "completionThreshold": 32,
        "happyImageSrc": "/happy-corgi-level-1.svg",
        "sadImageSrc": "/sad-corgi-level-1.svg"
    },
    {
        "namePrefix": "Mission 2",
        "nameSuffix": "Phish and Detect",
        "description": "Okay partner, this one's tricky. Scammers are using AI to make their phishing messages and deepfakes look super convincing. I'll be right here with you as we learn to read carefully and spot the signs. Let's call these fakes out before they fool anyone!",
        "shortDescription": "Fake messages and deepfakes have never looked more real. Let's learn to read the signs and call the scammers' bluff, partner!",
        "categorySuffix": "level-2:phish and detect",
        "completionThreshold": 32,
        "happyImageSrc": "/happy-corgi-level-2.svg",
        "sadImageSrc": "/sad-corgi-level-2.svg"
    },
    {
        "namePrefix": "Mission 3",
        "nameSuffix": "Privacy Guardian",
        "description": "Did you know that everything you type into an AI tool goes somewhere? That made my ears perk up! Let's figure out together what counts as personal info, why oversharing can be risky, and how to rewrite prompts the safe way. Let's make sure we think before we type!",
        "shortDescription": "Anything you type into an AI tool travels somewhere beyond your screen. Let's work out what's safe to type and what's better kept to yourself.",
        "categorySuffix": "level-3:privacy guardian",
        "completionThreshold": 32,
        "happyImageSrc": "/happy-corgi-level-3.svg",
        "sadImageSrc": "/sad-corgi-level-3.svg"
    },
    {
        "namePrefix": "Mission 4",
        "nameSuffix": "Prompt Safety Expert",
        "description": "Alright, this one's different! There are guardian cats up ahead protecting secret flags, and we need to collect them all. These cats are tough and they know all about prompt injection and jailbreaking tricks. We'll need to understand how those attacks work if we want to outsmart them and grab the flags. Let's go get 'em, partner!",
        "shortDescription": "Some clever tricks can talk an AI into breaking its own rules. Let's learn how prompt injection and jailbreaks work and how to shut them down!",
        "categorySuffix": "level-4:prompt safety expert",
        "completionThreshold": 15,
        "happyImageSrc": "/happy-corgi-level-4.svg",
        "sadImageSrc": "/sad-corgi-level-4.svg"
    },
    {
        "namePrefix": "Mission 5",
        "nameSuffix": "Rogue Agent",
        "description": "An AI agent with the wrong instructions and too much access can be risky, but that's where you come in! In this mission, you'll explore how agentic AI systems can be manipulated, see what attackers might try when they exploit one, and learn how the right defenses keep things under control. Stay curious, trust your instincts, and keep going. You're building the skills to handle this.",
        "shortDescription": "What happens when an AI agent goes rogue? Let's find out how attackers turn one against you, and how the right defenses shut that down.",
        "categorySuffix": "level-5:rogue agent",
        "completionThreshold": 32,
        "happyImageSrc": "/happy-corgi-level-5.svg",
        "sadImageSrc": "/sad-corgi-level-5.svg"
    }
]
